import React from "react";
import ServicesPage from "../component/ServicesPage";
import Footer from "../component/Footer";
const ServiceMainPage = () => {
  return (
    <div className="relative w-full h-52 bg-gray-100 mt-8">
      <ServicesPage />
      <Footer />
    </div>
  );
};

export default ServiceMainPage;
